export const getFrequentData = "admin/v2/getFrequentData"
export const getNonFrequentData = "admin/v2/getNonFrequentData"